import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { UserInfoService } from "../userInfo.service";

@Injectable()
export class AppResolver implements Resolve<any> {
    
    constructor(private userInfoService: UserInfoService) { }

    resolve() : Promise<any> {
        return this.userInfoService.getUserInfo();
    }
}